import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import SurfaceSection from '../Common/SurfaceSection';


export const Diagrams = styled(Box)`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    min-height: 0;
`;

export const LocationStaffWrapper = styled(Box)`
    flex-shrink: 0;
    min-height: 0;
    overflow: auto;
`;

export const GaugesContainer = styled(Box)`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    padding-right: ${({ theme }) => theme.spacing(2.5)};
`;

export const GaugeWrapper = styled(SurfaceSection)`
    align-items: center;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    min-height: 0;
    overflow: hidden;
    text-align: center;
`;

export const GaugeLabel = styled(Typography)<{ isSmall?: boolean }>(({ isSmall, theme }) => ({
    fontSize: isSmall ? theme.typography.body2.fontSize : theme.typography.body2.fontSize,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}));

export const ProgressBarWrapper = styled(SurfaceSection)(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    justifyContent: 'center',
    minHeight: 0,
    overflow: 'hidden',
    textAlign: 'center',
    '> *:first-of-type': {
        flex: '1 1 0',
        minHeight: 0,
        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            flex: '0 0 auto',
        },
    },
    '> *:last-of-type': {
        flexShrink: 0,
    },
}));
